/**
 * Trio de handlers (add/remover/marcar-principal) + `onChangeItem` para uma
 * lista dentro de `formFields` onde cada item tem um campo `principal`
 * mutuamente exclusivo — extraído na 3ª ocorrência (AW2-1134: Endereços
 * Etapa 3, Telefones Etapa 4, E-mails Etapa 5), mesma regra "2x aceitável,
 * 3ª extrai" já em uso no módulo (ver `useSessaoDialogMutacao.js`).
 *
 * Porta os mesmos 4 comportamentos já confirmados por leitura direta dos 3
 * componentes reais equivalentes (`EnderecosV2`/`TelefonesV2`/`SimpleEmails`):
 * - `onAdicionarItem`: novo item nasce com o campo `principal` do
 *   `buildItemVazio()` (tipicamente `false`), EXCETO quando é o 1º item da
 *   lista (lista antes vazia) — nesse caso nasce `principal: true`. Caminho
 *   confirmado alcançável nos 3 componentes reais (`addTelefoneHandler`/
 *   `addEmailHandler`: `if (lista.length === 0) principal = true`).
 * - `onRemoverItem`: se o item removido era o principal, promove o novo
 *   índice 0 (do array já sem o removido) — nunca fica sem nenhum item
 *   principal enquanto a lista não estiver vazia.
 * - `onMarcarPrincipal`: desmarca todos antes de marcar o clicado — nunca 2
 *   itens principais simultâneos.
 * - `onChangeItem`: atualiza um campo qualquer de um item pelo índice.
 *
 * `setFormFields` é o setter do `useState` do formulário inteiro (não só da
 * lista) — os 4 handlers leem/escrevem `atual[chave]`, preservando o
 * restante de `formFields` intacto.
 */
export default function useListaComPrincipal(setFormFields, chave, buildItemVazio) {
  const onChangeItem = (index, campo, valor) => {
    setFormFields((atual) => {
      const lista = [...atual[chave]];
      lista[index] = { ...lista[index], [campo]: valor };
      return { ...atual, [chave]: lista };
    });
  };

  const onAdicionarItem = () => {
    setFormFields((atual) => {
      const novoItem = { ...buildItemVazio(), principal: atual[chave].length === 0 };
      return { ...atual, [chave]: [...atual[chave], novoItem] };
    });
  };

  const onRemoverItem = (index) => {
    setFormFields((atual) => {
      const lista = [...atual[chave]];
      const [removido] = lista.splice(index, 1);
      if (removido?.principal && lista.length > 0) {
        lista[0] = { ...lista[0], principal: true };
      }
      return { ...atual, [chave]: lista };
    });
  };

  const onMarcarPrincipal = (index) => {
    setFormFields((atual) => {
      const lista = atual[chave].map((item, i) => ({ ...item, principal: i === index }));
      return { ...atual, [chave]: lista };
    });
  };

  return {
    onChangeItem, onAdicionarItem, onRemoverItem, onMarcarPrincipal,
  };
}
